<template>
  <div>
    <div v-for="(item, value) of items" :key="value" :class="$style.wrapper">
      <div :class="[$style.item, { [$style.open]: item.isOpen }]" @click="toggleOpen(item)">
        <div :class="$style.itemSummary">
          <div :class="$style.itemSummaryContent">
            <div :class="$style.icon">
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M8 1V15" stroke="#1D1D1F" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M1 8H15" stroke="#1D1D1F" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
              </svg>
            </div>
            <span :class="$style.title" v-html="item.title"></span>
          </div>
          <span :class="$style.additionalText" v-if="item.additionalText" v-html="item.additionalText"></span>
        </div>
        <p :class="$style.description" v-html="item.description" v-show="item.isOpen"></p>
      </div>
      <CookieSwitcher
        v-if="item.switcher"
        :value="item.category"
        :checked="settings[item.category]"
        @change="checkboxHandler($event.target)"
      />
    </div>
  </div>
</template>

<script>
import CookieSwitcher from './CookieSwitcher.vue';

export default {
  name: 'CookieSettingsItems',
  components: {
    CookieSwitcher,
  },
  props: {
    items: Array,
    settings: Object,
  },

  methods: {
    toggleOpen(item) {
      item.isOpen = !item.isOpen;

      this.items.forEach((el) => {
        if (item.title !== el.title) {
          el.isOpen = false;
        }
      });
    },
    checkboxHandler(e) {
      this.settings[e.value] = e.checked;
    },
  },
};
</script>

<style module lang="scss">
@use '~styles/core/_variables.scss' as vars;
@use '~styles/core/_mixins.scss' as mixins;

$hoverColor: #534bc3;

.item {
  border-bottom: 1px solid #e5e5e5;
}

.open {
  .itemSummary {
    padding-bottom: 0.5rem;
  }

  .icon {
    path {
      &:first-child {
        transform: rotate(90deg);
      }
    }
  }
}

.itemSummaryContent {
  display: flex;
}

.wrapper {
  position: relative;

  &:first-child {
    .itemSummary {
      padding-top: initial;
    }
  }

  &:last-child {
    .item {
      border-bottom: initial;
    }

    .item:not(.open) {
      .itemSummary {
        padding-bottom: initial;
      }
    }

    .description {
      padding-bottom: initial;
    }
  }
}

.itemSummary {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1.8rem 0;
  cursor: pointer;
  list-style: none;

  @include mixins.media(md) {
    padding: 2.2rem 0;
  }

  @include mixins.hover {
    &:hover {
      .icon {
        svg path {
          stroke: $hoverColor;
        }
      }

      .title {
        color: $hoverColor;
      }
    }
  }

  &::-webkit-details-marker {
    display: none;
  }

  &-content {
    display: flex;
  }
}

.additionalText {
  @include mixins.font(1.6rem, 1.4);

  font-weight: vars.$fontWeightBase;
  position: absolute;
  top: 0;
  right: 0;
  color: #89898a;

  @include mixins.media(md) {
    @include mixins.font(1.8rem, 1.5);

    top: -5px;
  }
}

.title {
  @include mixins.font(1.6rem, 1.4);

  font-weight: vars.$fontWeightBase;
  padding-left: 1rem;
  margin-right: auto;
  transition: 0.3s;

  @include mixins.media(md) {
    @include mixins.font(1.8rem, 0.89);
  }
}

.description {
  @include mixins.font(1.4rem, 1.45);

  font-weight: vars.$fontWeightLight;
  letter-spacing: -0.005em;
  padding-top: 0.5rem;
  padding-bottom: 16px;
  padding-left: 2.6rem;

  @include mixins.media(md) {
    @include mixins.font(1.6rem, 1.45);
  }

  a {
    color: #534bc3;

    @include mixins.hover {
      &:hover {
        color: #fa633e;
      }
    }
  }
}

.icon {
  display: flex;
  align-items: center;

  path {
    transform-origin: center;
  }
}
</style>
